module.exports =
  gql: '/internal/featureFlag/gql'


// WEBPACK FOOTER //
// ./~/oo-routes/routes/featureFlag.coffee